export default __webpack_public_path__ + "static/media/icon_edit.0c62c7b9.svg";